export default {"src":"/_next/static/image/public/images/ic_trusted_shipping.0a70991fbd3356b059923c210fa04a09.svg","height":29,"width":41};